<template>
  <div class="M365Report container-fluid">
    <div class="main-content">
      <m365-Report-filter-bar @selectedGroupObj="setGroupCourseObj" @selectedCohortObj="setCohortObj" @selectedMOTDObj="setMOTDObj" v-bind:showExport="showExportButton" @isExportBtnClicked="exportCSV" @isViewBtnClicked="updateViewBtnClickedFlag"></m365-Report-filter-bar>
      <hr width="97%" size="10px">
      <div class="row margin-Top-2Perc">
        <div class="col-md-11 col-lg-11 width margin-left-2Perc">
          <sortable-list v-if="showM365ReportList" v-bind:responseObj="getM365ReportArr" v-bind:sortableColumnName="sortColumnNames" v-bind:columnNameToShow="columnNameToShow" v-bind:linkColumnName="linkColumnNames" v-bind:selectedsubOption="1"></sortable-list>
        </div>
      </div>
      <div class="row margin-Top-3Perc">
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
          <Copyright-Element class="footer"></Copyright-Element>
        </div>
      </div>
      <alert-box v-if="showAlertDialog" v-bind:errorMsg="errorMsg" @showAlertBox="updateShowAlertDialogFlag"></alert-box>
      <!-- Show Spinner -->
      <div class="animationload" v-show="showSpinner">
        <div class="osahanloading"></div>
      </div>
      <loader></loader>
    </div>
    <error-page v-if="isUserGroupAdmin"></error-page>        
  </div>  
</template>

<script>
import Loader from '@/components/dashboard/Loader'
import m365ReportFilterBar from '@/components/reports/m365_report/m365ReportFilterBar'
// import ReportGroupFilterBar from '@/components/ReportGroupFilterBar'
import list from '@/pages/SortableList'
import moment from 'moment'
import CopyrightElement from '@/components/CopyrightElement'
import { constants } from '@/utils/constants'
import { reportService } from '@/server-util/report-service'
import AlertBox from '@/components/AlertOverlay'
import csvHelper from '@/utils/csv-helper'
import ErrorPage from '@/pages/Error'
import { dmAdminUtils } from '@/utils/dmAdminUtils'
import { participantService } from '@/server-util/participant-service'
export default {
  created: function () {
    this.checkUserErrorStatus()
  },
  data: function () {
    return {
      selectedGroupCourseObj: null,
      selectedCohortObj: null,
      selectedMOTDObj: null,
      selectedGroupObj: null,
      showExportButton: true,
      showAlertDialog: false,
      errorMsg: '',
      showSpinner: false,
      lessonwiseProgressRespArr: [],
      reportRespArr: [],
      showM365ReportList: false,
      sortColumnNames: ['ParticipantName', 'ParticipantEmail', 'TotalElements', 'ElementsViewed', 'ElementsCompleted', 'TotalVideos', 'VideosCompleted', 'TotalQuestions', 'QuestionsAnswered', 'TotalChallenges', 'ChallengesResponded', 'PostElementViews', 'MOTDRating'],
      columnAlias: [],
      columnRespKey: [],
      columnNameToShow: [],
      linkColumnNames: [],
      responseToPass: [],
      isExportBtnClicked: false,
      isViewBtnClicked: false,
      csvFileName: ''
    }
  },
  components: {
    'm365-Report-filter-bar': m365ReportFilterBar,
    'Copyright-Element': CopyrightElement,
    'sortable-list': list,
    'alert-box': AlertBox,
    'error-page': ErrorPage,
    'loader': Loader
  },
  methods: {
    checkUserErrorStatus: function () {
      var storeObj = this.$store
      if (storeObj.state.access_token !== undefined && storeObj.state.access_token !== null && storeObj.state.access_token !== '') {
        participantService
          .getUserErrorStatus(
            storeObj.state.access_token
          )
          .then(responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              const jsonObj = responseObj.data
              this.checkAndShowAlert(jsonObj)
            }
          }, errorObj => {
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
            console.log('getUserErrorStatus Error :::' + this.errorMsg)
          })
      } else {
        console.log(
          'Access Token or required data is NULL hence declined LOADING GET ERROR INFO'
        )
      }
    },
    checkAndShowAlert: function (jsonObj) {
      if (jsonObj !== undefined && jsonObj !== 'undefined' && jsonObj !== null && jsonObj !== 'null' && jsonObj !== '') {
        const isLoggedOut = jsonObj.IsAdminLoggedOut
        const profileError = jsonObj.ProfileError
        if (isLoggedOut) {
          this.showAlertDialog = true
          this.errorMsg = constants.Logged_Out_From_Another_Platform_Error_Msg
        } else if (profileError === constants.Change_Password_Error_Profile) {
          this.showAlertDialog = true
          this.errorMsg = constants.Change_Password_Alert_Msg
        }
      }
    },
    peformCleanUpOperationOnSignOut: function () {
      var store = this.$store
      var cookies = this.$cookies
      cookies.remove(constants.LOGIN_COOKIE_KEY)
      cookies.remove(constants.LOGIN_USER_COOKIE)
      store.state.isUserProfileLoaded = false
      localStorage.removeItem(constants.LOGIN_USER_COOKIE)
      localStorage.setItem('selectedMenu', 0)
      localStorage.setItem('selectedSubMenu', 0)
      localStorage.clear()
      this.$store.state.curr_user = null
      this.$store.commit('resetState')
      this.$router.push('/')
    },
    updateShowAlertDialogFlag (value) {
      this.showAlertDialog = value
      switch (this.errorMsg) {
        case constants.Logged_Out_From_Another_Platform_Error_Msg:
          this.peformCleanUpOperationOnSignOut()
          break
        case constants.Change_Password_Alert_Msg:
          localStorage.setItem('selectedMenu', constants.MenuOptionsEnum.Settings)
          localStorage.setItem('selectedSubMenu', constants.SubMenuOptionsEnum.EditProfile)
          this.$router.push('/profile?OpenPopUp=true')
          break
      }
    },
    setMOTDObj (value) {
      // AK: When user selected particular MOTD object then update it in parent file too
      this.selectedMOTDObj = value
    },
    setGroupCourseObj (value) {
      // AK: When user selected particular group course object then update it in parent file too
      this.selectedGroupCourseObj = value
    },
    setCohortObj (value) {
      // AK: When user selected particular cohort object then update it in parent file too
      this.selectedCohortObj = value
    },
    updateViewBtnClickedFlag (value) {
      this.isViewBtnClicked = value
      if (value) {
        this.getM365Report()
      }
    },
    exportCSV (value) {
      this.isExportBtnClicked = value
      if (value) {
        this.getM365Report()
      }
    },
    bindColumnsNameAndAlias: function () {
      this.columnNameToShow = []
      for (var i = 0; i < this.columnRespKey.length; i++) {
        var obj = {
          ColumnName: this.columnRespKey[i],
          ColumnAlias: this.columnAlias[i]
        }
        this.columnNameToShow.push(obj)
      }
      this.processAndExecuteSelectedOperation()
      // console.log('Column And alias Name Obj >>>> ' + JSON.stringify(this.columnNameToShow))
    },
    /*
    setGroupObj (value) {
      // AK: When user selected particular Group object then update it in parent file too
      this.selectedGroupObj = value
    }, */
    getM365Report: function () {
      var storeObj = this.$store
      var _this = this
      this.reportRespArr = []
      if (this.selectedCohortObj.CohortId !== null && this.selectedCohortObj.CohortId !== undefined && this.selectedCohortObj.CohortId !== '' && this.selectedMOTDObj.ModuleId !== null && this.selectedMOTDObj.ModuleId !== undefined && this.selectedMOTDObj.ModuleId !== 'null') {
        this.$store.state.isLoading = true
        reportService.getM365Reports(storeObj.state.access_token, _this.selectedMOTDObj.ModuleId, _this.selectedGroupCourseObj.GroupCourseMasterId, _this.selectedCohortObj.CohortId).then(
          responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              // AK: Hide Spinner after recieving Reports
              _this.$store.state.isLoading = false
              _this.reportRespArr = responseObj.data
              // console.log('this.selectedMOTDObj >>> ' + JSON.stringify(_this.reportRespArr))
              if (parseInt(_this.reportRespArr.length) === 0) {
                this.showAlertDialog = true
                this.errorMsg = 'No report found for \'' + this.selectedMOTDObj.Title + '\' Lesson.'
                this.showM365ReportList = false
              } else {
                this.addColumnAlias()
              }
            } else {
              // AK: Hide Spinner
              // _this.showSpinner = false
              _this.$store.state.isLoading = false
              this.showAlertDialog = true
              this.errorMsg =
                'Oops! Something went wrong. Please try again.'
            }
          },
          errorObj => {
            // AK: Hide Spinner
            // _this.showSpinner = false
            _this.$store.state.isLoading = false
            this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
          }
        )
      } else {
        console.log('VALUES are NULL hence declined LOADING Mentora Moments Report List')
      }
    },
    addColumnAlias: function () {
      this.columnAlias = []
      var prefixToAdd = this.selectedGroupCourseObj.CourseMasterType === constants.CourseType.M365 ? 'Moment' : 'Course'
      this.columnAlias = ['Participant', 'Email', 'Username', 'Group', `${prefixToAdd} Name`, `${prefixToAdd} Release-date`, 'Cohort', 'Logged In?', 'Notification Clicked', `${prefixToAdd} Viewed`, `${prefixToAdd} Completed`, 'Activity Duration', 'Total Content Screens', 'Content Screens Viewed', 'Total Elements', 'Elements Viewed', 'Elements Completed', 'Total Videos', 'Videos Completed', 'Total Questions', 'Questions Answered', 'Total Challenges', 'Challenges Responded to', 'Bookmarked?', '# of Rating screen Views', `${prefixToAdd} Rating`]
      this.addColumnRespKey()
    },
    addColumnRespKey: function () {
      this.columnRespKey = []
      this.columnRespKey = ['ParticipantName', 'ParticipantEmail', 'ParticipantUserName', 'GroupName', 'MOTD', 'MOTDReleaseTS', 'Cohort', 'LoggedIn', 'NotificationClicked', 'M365HomeViewed', 'MOTDCompleted', 'ActivityDuration', 'TotalContentScreens', 'ContentScreensViewed', 'TotalElements', 'ElementsViewed', 'ElementsCompleted', 'TotalVideos', 'VideosCompleted', 'TotalQuestions', 'QuestionsAnswered', 'TotalChallenges', 'ChallengesResponded', 'Favorited', 'PostElementViews', 'MOTDRating']
      this.bindResponseObj()
    },
    formatAndShowDate: function (date) {
      if (date !== undefined) {
        var dateToPass = date
        if (dateToPass.indexOf('Z') === -1) {
          dateToPass += 'Z'
        }
        return dmAdminUtils.formatDateAndTime(dateToPass)
      }
    },
    bindResponseObj: function () {
      this.responseToPass = []
      for (var i = 0; i < this.reportRespArr.length; i++) {
        var seconds = this.reportRespArr[i].ActivityDuration
        var hours = Math.floor(moment.duration(seconds, 'seconds').asHours()) < 10 ? '0' + Math.floor(moment.duration(seconds, 'seconds').asHours()) : Math.floor(moment.duration(seconds, 'seconds').asHours())
        var min = moment.duration(seconds, 'seconds').minutes() < 10 ? '0' + moment.duration(seconds, 'seconds').minutes() : moment.duration(seconds, 'seconds').minutes()
        var sec = moment.duration(seconds, 'seconds').seconds() < 10 ? '0' + moment.duration(seconds, 'seconds').seconds() : moment.duration(seconds, 'seconds').seconds()
        var format = hours + ':' + min + ':' + sec
        var obj = {
          'ParticipantName': this.reportRespArr[i].ParticipantName,
          'ParticipantEmail': this.reportRespArr[i].ParticipantEmail,
          'ParticipantUserName': this.reportRespArr[i].ParticipantUserName,
          'GroupName': this.reportRespArr[i].GroupName,
          'MOTD': this.reportRespArr[i].MOTD,
          'MOTDReleaseTS': this.formatAndShowDate(this.reportRespArr[i].MOTDReleaseTS),
          'Cohort': this.reportRespArr[i].Cohort,
          'LoggedIn': this.reportRespArr[i].LoggedIn ? 'Yes' : 'No',
          'NotificationClicked': this.reportRespArr[i].NotificationClicked ? 'Yes' : 'No',
          'M365HomeViewed': this.reportRespArr[i].M365HomeViewed ? 'Yes' : 'No',
          'MOTDViewed': this.reportRespArr[i].ElementsViewed > 0 ? 'Yes' : 'No',
          'MOTDCompleted': this.reportRespArr[i].MOTDCompleted ? 'Yes' : 'No',
          'ActivityDuration': format,
          'TotalContentScreens': this.reportRespArr[i].TotalContentScreens,
          'ContentScreensViewed': this.reportRespArr[i].ContentScreensViewed,
          'TotalElements': this.reportRespArr[i].TotalElements === 0 ? 'NA' : this.reportRespArr[i].TotalElements,
          'ElementsViewed': this.reportRespArr[i].TotalElements === 0 ? 'NA' : this.reportRespArr[i].ElementsViewed,
          'ElementsCompleted': this.reportRespArr[i].TotalElements === 0 ? 'NA' : this.reportRespArr[i].ElementsCompleted,
          'TotalVideos': this.reportRespArr[i].TotalVideos === 0 ? 'NA' : this.reportRespArr[i].TotalVideos,
          'VideosCompleted': this.reportRespArr[i].TotalVideos === 0 ? 'NA' : this.reportRespArr[i].VideosCompleted,
          'TotalQuestions': this.reportRespArr[i].TotalQuestions === 0 ? 'NA' : this.reportRespArr[i].TotalQuestions,
          'QuestionsAnswered': this.reportRespArr[i].TotalQuestions === 0 ? 'NA' : this.reportRespArr[i].QuestionsAnswered,
          'TotalChallenges': this.reportRespArr[i].TotalChallenges === 0 ? 'NA' : this.reportRespArr[i].TotalChallenges,
          'ChallengesResponded': this.reportRespArr[i].TotalChallenges === 0 ? 'NA' : this.reportRespArr[i].ChallengesResponded,
          'Favorited': this.reportRespArr[i].Favorited ? 'Yes' : 'No',
          'PostElementViews': this.reportRespArr[i].PostElementViews,
          'MOTDRating': this.reportRespArr[i].MOTDRating
        }
        this.responseToPass.push(obj)
      }
      // console.log('this.responseToPass >>>> ' + JSON.stringify(this.responseToPass))
      this.bindColumnsNameAndAlias()
    },
    processAndExecuteSelectedOperation: function () {
      if ((!this.isExportBtnClicked) && this.isViewBtnClicked) {
        // AK: If export btn not clicked and list is shown previously then show list only
        this.showM365ReportList = true
      } else if (this.isExportBtnClicked && (!this.isViewBtnClicked)) {
        // AK: If user directly clicked on export button without clicking view first then export data
        this.exportData()
      } else if (this.isExportBtnClicked && this.isViewBtnClicked) {
        // AK: If user performed both operations then performed both operations
        this.showM365ReportList = true
        this.exportData()
      }
    },
    exportData: function () {
      return csvHelper.export(this.getM365ReportArr, this.columnRespKey, this.columnAlias, 'Mentora365 - ' + this.selectedMOTDObj.Title + ' (' + this.selectedCohortObj.CohortName + ')')
    }
  },
  computed: {
    getM365ReportArr: {
      get: function () {
        return this.responseToPass
      }
    },
    isUserGroupAdmin: {
      get: function () {
        var userObj = this.$store.state.curr_user
        if (parseInt(userObj.AccountType) === parseInt(constants.UserAccountType.Group_Admin)) {
          return true
        } else {
          return false
        }
      }
    }
  },
  name: 'M365Report'
}
</script>

<style scoped>
.M365Report {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
.animationload {
  height: 100%;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 10000;
}
.osahanloading {
  animation: 1.5s linear 0s normal none infinite running osahanloading;
  background: #fed37f none repeat scroll 0 0;
  border-radius: 50px;
  height: 50px;
  left: 50%;
  margin-left: -25px;
  margin-top: -25px;
  position: absolute;
  top: 50%;
  width: 50px;
}
.osahanloading::after {
  animation: 1.5s linear 0s normal none infinite running osahanloading_after;
  border-color: #85d6de transparent;
  border-radius: 80px;
  border-style: solid;
  border-width: 10px;
  content: "";
  height: 80px;
  left: -15px;
  position: absolute;
  top: -15px;
  width: 80px;
}
@keyframes osahanloading {
  0% {
    transform: rotate(0deg);
  }
  50% {
    background: #85d6de none repeat scroll 0 0;
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.width {
  width: 100% !important;
}
.width1 {
  width: 97.3% !important;
}
.margin-left-0point2Perc {
  margin-left: 0.2% !important;
}
.margin-left-1point6Perc {
  margin-left: 1.6% !important;
}
.margin-Top-2Perc {
  margin-top: 2%;
}
.font-size-20px
{
  font-size:20px;
}
.margin-Top-1Perc {
  margin-top: 1%;
}
.black-border {
  border: 1px solid #aaa;
}
.custom-btn {
  padding: 5px 12px !important;
}
.padding-Left-30px {
  padding-left: 3% !important;
}
.white-BG {
  background-color: #ffffff;
}
.padding-Left-0px {
  padding-left: 0px !important;
}
.padding-right-0px {
  padding-right: 0px !important;
}
.margin-Top-3Perc{
  margin-top: 3% !important;
}
.margin-Top-5Perc{
  margin-top: 5% !important;
}
.margin-left-1Perc{
  margin-left: 1% !important;
}
.padding-bottom-0Perc{
  padding-bottom: 0px; 
}
/* Using Only for footer */
.footer{
  /* position: fixed; */
    left: 38px !important;
    bottom: 0 !important;
    width: 100% !important;
    /* background-color: red; */
    /* color: white; */
    text-align: center !important;
    margin-bottom: 1% !important;
    font-size: 12px !important;
}
.margin-Top-2Perc {
  margin-top: 2%;
}
.margin-left-1point6Perc {
  margin-left: 2.8% !important;
}
.width2 {
  width: 95.2% !important;
}
.margin-left-1point6Perc {
  margin-left: 2.8% !important;
}
</style>


// WEBPACK FOOTER //
// src/pages/M365Report.vue